import { useApiClient } from '@/composables/api-client'
import { createItemsStoreWrapper } from '~/utils/pinia/items-store-setup'
import type {
  FantasyCardGrades,
  FantasyShopCard,
  FantasyShopSet
} from '~/types/fantasy'

const createItemsStore = createItemsStoreWrapper<'id', FantasyShopSet>()

export const useFantasyShopSetListStore = createItemsStore(
  'fantasy-shop-set-list',
  {
    path: '/api/v1/fantasy/shop/sets',
    idKey: 'id',
    query: {
      expand: ['cards.player.team', 'cards.labels', 'cards.cardMember'],
      perPage: 4
    }
  },
  context => {
    const markCardOwned = (card: FantasyShopCard) => {
      card.cardMember = {}
    }

    const setBought = (setId: number) => {
      const set = context.items.value.find(item => item.id === setId)
      if (set) {
        set.can_buy = false
        set.cards.forEach(markCardOwned)
      }
    }

    const setBoughtCard = (cardId: number) => {
      const set = context.items.value.find(
        set => set.cards.findIndex(card => card.id === cardId) > -1
      )
      if (set) {
        const card = set.cards.find(card => card.id === cardId)
        set.can_buy = false
        if (card) {
          markCardOwned(card)
        }
      }
    }

    const buySet = async ({
      setId,
      gradeId
    }: {
      setId: number
      gradeId: FantasyCardGrades
    }) => {
      const apiClient = await useApiClient()
      const body = { grade_id: gradeId }
      const data = await apiClient.post(
        `/api/v1/fantasy/shop/sets/${setId}/buy`,
        { body }
      )
      setBought(setId)
      return data
    }

    return { buySet, setBought, setBoughtCard }
  }
)
